import React from 'react';

export default function Scoreboard({ scores, currentTeamId, stops = [], hidePoints = false, hideScoreboard = false }) {
  const sortedStops = [...stops].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  const visibleScores = hideScoreboard
    ? scores.filter(t => t.id === currentTeamId)
    : scores;

  return (
    <div className="scoreboard">
      <h2>Poengtavle</h2>
      <div className="score-rows">
        {visibleScores.map((team, index) => {
          const rank = hideScoreboard
            ? scores.findIndex(t => t.id === team.id) + 1
            : index + 1;
          return (
            <div
              key={team.id}
              className={`score-row ${team.id === currentTeamId ? 'current' : ''}`}
            >
              <div className="score-rank">#{rank}</div>
              <div className="score-info">
                <span className="score-team-name">{team.name}</span>
                <span className="score-details">
                  {team.stops_completed} stopp · {team.generic_completed} utfordringer
                </span>
              </div>
              {!hidePoints && <div className="score-points">{team.total_points}p</div>}
            </div>
          );
        })}
      </div>

      {sortedStops.length > 0 && (
        <>
          <h2 className="stops-list-heading">Attraksjoner</h2>
          <div className="stops-list">
            {sortedStops.map(stop => {
              const isCompleted = stop.completed_by_teams?.includes(currentTeamId);
              return (
                <div key={stop.id} className={`stops-list-row ${isCompleted ? 'done' : ''}`}>
                  <span className="stops-list-year">{stop.year}</span>
                  <span className="stops-list-name">{stop.title}</span>
                  {isCompleted && <span className="stops-list-check">✓</span>}
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
